import React from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

const getPath = direction => {
  switch (direction) {
    case 'left':
    case 'back':
      return 'M8.15,12.35l6,6a.5.5,0,0,0,.71-.71L9.21,12l5.65-5.65a.5.5,0,1,0-.71-.71l-6,6A.5.5,0,0,0,8.15,12.35Z';
    case 'right':
    case 'forward':
    default:
      return 'M16.35,11.65l-6-6a.5.5,0,0,0-.71.71L15.29,12,9.65,17.65a.5.5,0,1,0,.71.71l6-6A.5.5,0,0,0,16.35,11.65Z';
    case 'up':
      return 'M12 8.5c.1 0 .3 0 .4.1l6 6c.2.2.2.5 0 .7-.2.2-.5.2-.7 0L12 9.7l-5.6 5.6c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7l6-6s.2-.1.3-.1z';
    case 'down':
      return 'M12 15.5c-.1 0-.3 0-.4-.1l-6-6c-.2-.2-.2-.5 0-.7s.5-.2.7 0l5.7 5.6 5.6-5.6c.2-.2.5-.2.7 0s.2.5 0 .7l-6 6s-.2.1-.3.1z';
  }
};

const Arrow = ({ className, direction, height, strokeColor, width }) => (
  <SVGElement
    className={className}
    height={height}
    viewBox="0 0 24 24"
    width={width}
  >
    <path fill={strokeColor} d={getPath(direction)} />
  </SVGElement>
);

Arrow.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['right', 'left', 'forward', 'back']),
  height: PropTypes.string,
  strokeColor: PropTypes.string,
  width: PropTypes.string,
};

Arrow.defaultProps = {
  direction: 'forward',
  height: '1.5rem',
  strokeColor: '#979797',
  width: '1.5rem',
};

export default React.memo(Arrow);
